module.exports = __webpack_public_path__ + "img/header-img.fb6946f0.png";